export default class PitchToggle {
  mode = '';
  minZoom = 12

  constructor ({
    bearing = -20,
    pitch = 70,
    minpitchzoom = null
  }) {
    this._bearing = bearing
    this._pitch = pitch
    this._minpitchzoom = minpitchzoom
  }

  toggle = function (onzoom) {
    if (this._map.getPitch() === 0) {
      this.mode = '3d'
      this._map.setMaxPitch(60)
      let options = {
        pitch: this._pitch,
        bearing: this._bearing
      }
      if (this._minpitchzoom && this._map.getZoom() > this._minpitchzoom) {
        options.zoom = this._minpitchzoom
      }

      this._map.easeTo(options)
      this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-2d'

      this._map.setLayoutProperty('total_accidents', 'visibility', 'none')
      this._map.setLayoutProperty('casualtie_accidents', 'visibility', 'none')
      this._map.setLayoutProperty(
        'point_fatal_accidents',
        'visibility',
        'none'
      )

      this._map.setLayoutProperty('omd_accidents', 'visibility', 'visible')
      this._map.setLayoutProperty('injured_accidents', 'visibility', 'visible')
      this._map.setLayoutProperty('fatal_accidents', 'visibility', 'visible')
    } else {
      this.mode = '2d'
      this._map.setMaxPitch(0)
      if (!onzoom) {
        this._map.easeTo({
          pitch: 0,
          bearing: 0
        })
      } else {
        this._map.setPitch(0)
        this._map.setBearing(0)
      }
      this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-3d'

      this._map.setLayoutProperty('omd_accidents', 'visibility', 'none')
      this._map.setLayoutProperty('injured_accidents', 'visibility', 'none')
      this._map.setLayoutProperty('fatal_accidents', 'visibility', 'none')

      this._map.setLayoutProperty('total_accidents', 'visibility', 'visible')
      this._map.setLayoutProperty(
        'casualtie_accidents',
        'visibility',
        'visible'
      )
      this._map.setLayoutProperty(
        'point_fatal_accidents',
        'visibility',
        'visible'
      )
    }
    this.setBtn()
  }

  checkOnZoom = function () {
    if (this._map.getZoom() < this.minZoom) {
      if (this._map.getPitch() !== 0) {
        this.toggle(true)
      }
      this._btn.classList.add('disabled')
    } else {
      this._btn.classList.remove('disabled')
    }
  }

  onAdd = function (map) {
    var _this = this
    _this._map = map

    _this.mode = '2d'

    _this._btn = document.createElement('button')
    _this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-3d'
    _this._btn.type = 'button'
    _this._btnText = document.createElement('strong')
    _this._btnText.innerText = '3D'
    _this._btn.appendChild(_this._btnText)
    _this._btn['aria-label'] = 'Toggle Pitch'
    _this._btn.onclick = function () {
      if (_this._map.getZoom() >= _this.minZoom) {
        _this.toggle(false)
      }
    }

    _this._container = document.createElement('div')
    _this._container.className = 'mapboxgl-ctrl-group mapboxgl-ctrl'
    _this._container.appendChild(_this._btn)

    _this.checkOnZoom()

    map.on('zoom', function () {
      _this.checkOnZoom()
    })

    return _this._container
  }

  setBtn = function () {
    if (this.mode === '2d') {
      this._btnText.innerText = '3D'
    } else {
      this._btnText.innerText = '2D'
    }
  }

  onRemove = function () {
    this._container.parentNode.removeChild(this._container)
    this._map = undefined
  }
}
